export const NAV_MAX_LENGTH = 7;
// TODO: Assuming these will eventually be translated and provided by AEM.
export const STR_OPEN_MENU = 'Open menu';
export const STR_CLOSE_MENU = 'Close menu';
export const MEMBER_BENEFITS_LINK = 'https://www.marriott.com/loyalty/member-benefits/';
